// extracted by mini-css-extract-plugin
module.exports = {"container":"room__CheckboxGroup-styles__container___vu6xYH","trigger":"room__CheckboxGroup-styles__trigger___2_lkDd"};